import {
  createBiLogger as createCliBiLogger,
  reportCommandStartEvent as originalReportCommandStartEvent,
} from '@wix/cli-telemetry';
import { getUnknownFailureMessage, isCliSystemError } from '@wix/cli-error';
import type { ErrorReporter } from '@wix/cli-error-reporting';
import { wixCliCliError } from '@wix/bi-logger-dev-tools-data/v2';
import type { Command } from '@commander-js/extra-typings';

export const createBiLogger = async ({
  errorReporter,
  cliVersion,
  cliSessionId,
  userId,
  aiAgentName,
  command,
}: {
  errorReporter: ErrorReporter;
  cliVersion: string;
  cliSessionId: string;
  userId?: string;
  aiAgentName?: string;
  command: string;
}) => {
  const biLogger = await createCliBiLogger({
    aiAgentName,
    command,
    cliSessionId,
    cliVersion,
    userId,
  });

  errorReporter.on('errorReported', (error) => {
    void biLogger.report(
      wixCliCliError({
        errorMessage: getUnknownFailureMessage(error),
        errorType: isCliSystemError(error) ? 'SystemError' : 'UserError',
        errorName: error.name,
      })
    );
  });

  function reportCommandStartEvent(commandToReport: Command) {
    // creating a custom object because we need to change the name of the command
    const commandFields = {
      name: () => command,
      args: commandToReport.args,
      opts: () => commandToReport.opts(),
    };

    return originalReportCommandStartEvent({
      biLogger,
      command: commandFields,
      cliVersion,
      flow: 'Headless',
    });
  }

  return {
    biLogger,
    reportCommandStartEvent,
  };
};
